import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  imports: [FormsModule, RouterLink],
  templateUrl: './reset-password.html',
})
export class ResetPassword {
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  // better-auth validates the emailed link server-side, then redirects the
  // browser here with either ?token=... or ?error=INVALID_TOKEN.
  private readonly token = this.route.snapshot.queryParamMap.get('token');
  protected readonly invalidLink =
    !this.token || this.route.snapshot.queryParamMap.get('error') === 'INVALID_TOKEN';

  protected readonly newPassword = signal('');
  protected readonly confirmPassword = signal('');
  protected readonly submitting = signal(false);
  protected readonly error = signal<string | null>(null);

  protected async submit(): Promise<void> {
    if (this.submitting() || !this.token) return;
    this.error.set(null);

    const newPassword = this.newPassword();
    if (!newPassword) {
      this.error.set('Enter a new password.');
      return;
    }
    if (newPassword !== this.confirmPassword()) {
      this.error.set('New password and verification do not match.');
      return;
    }

    this.submitting.set(true);
    const { error } = await this.auth.resetPassword({ newPassword, token: this.token });
    this.submitting.set(false);
    if (error) {
      this.error.set(error);
      return;
    }
    void this.router.navigate(['/login'], { queryParams: { reset: '1' } });
  }
}